module.exports = __webpack_public_path__ + "img/call-center-start.57c053e9.png";